import React, { useState, useEffect, useCallback, useRef } from "react";
import "./Dashboard.scss";
import DownloadPdfPopup from "../Download-PDF-Popup/DownloadPdfPopup";
const Dashboard = () => {
  const [show, setShow] = useState(false);
  const openPdfPopup = () => {
    setShow(true);
    debugger;
  };
  return (
    <div className="main">
      <DownloadPdfPopup />
    </div>
  );
};

export default Dashboard;
